export const CustomShareIcon = () => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_21306_5392)">
			<path
				d="M19.25 11V15.8125C19.25 16.6948 18.5075 17.4167 17.6 17.4167H4.4C3.4925 17.4167 2.75 16.6948 2.75 15.8125V11"
				stroke="#636172"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.7051 5.56966C10.2532 5.37884 8.02497 5.56966 8.02497 12.4549"
				stroke="#636172"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M13.7676 9.43945L17.6457 5.5613L13.7676 1.68315"
				stroke="#636172"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_21306_5392">
				<rect width="22" height="22" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
